/* tslint:disable */
/* eslint-disable */
/**
 * Bulletin API
 * REST API for Bulletin platform
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DropdownItem } from './DropdownItem';
import {
    DropdownItemFromJSON,
    DropdownItemFromJSONTyped,
    DropdownItemToJSON,
} from './DropdownItem';
import type { ShopifyBrandOrders } from './ShopifyBrandOrders';
import {
    ShopifyBrandOrdersFromJSON,
    ShopifyBrandOrdersFromJSONTyped,
    ShopifyBrandOrdersToJSON,
} from './ShopifyBrandOrders';

/**
 * 
 * @export
 * @interface BrandResponse
 */
export interface BrandResponse {
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    brand_name?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    brand_description?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    logo_url?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    brand_bio_image_url?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    website_url?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    instagram_url?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    instagram_followers?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    based_in?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    product_arrival?: string;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    min_lead_time?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    max_lead_time?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    minimum_quantity?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    minimum_price?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof BrandResponse
     */
    categories?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResponse
     */
    is_published?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    increment?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResponse
     */
    instagram_growth_help?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    minimum_order_value?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    minimum_reorder_value?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    thumbnail_image_url?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    vanity_url_name?: string;
    /**
     * 
     * @type {Array<DropdownItem>}
     * @memberof BrandResponse
     */
    values?: Array<DropdownItem>;
    /**
     * 
     * @type {number}
     * @memberof BrandResponse
     */
    case_pack_quantity?: number;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    user_id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResponse
     */
    bulletin_plus_access_level?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResponse
     */
    onboarding_complete?: boolean;
    /**
     * 
     * @type {object}
     * @memberof BrandResponse
     */
    address?: object;
    /**
     * 
     * @type {object}
     * @memberof BrandResponse
     */
    fulfillment_address?: object;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    balance_id?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandResponse
     */
    phone_number?: string;
    /**
     * 
     * @type {ShopifyBrandOrders}
     * @memberof BrandResponse
     */
    shopify?: ShopifyBrandOrders;
}

/**
 * Check if a given object implements the BrandResponse interface.
 */
export function instanceOfBrandResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BrandResponseFromJSON(json: any): BrandResponse {
    return BrandResponseFromJSONTyped(json, false);
}

export function BrandResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'brand_name': !exists(json, 'brand_name') ? undefined : json['brand_name'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'brand_description': !exists(json, 'brand_description') ? undefined : json['brand_description'],
        'logo_url': !exists(json, 'logo_url') ? undefined : json['logo_url'],
        'brand_bio_image_url': !exists(json, 'brand_bio_image_url') ? undefined : json['brand_bio_image_url'],
        'website_url': !exists(json, 'website_url') ? undefined : json['website_url'],
        'instagram_url': !exists(json, 'instagram_url') ? undefined : json['instagram_url'],
        'instagram_followers': !exists(json, 'instagram_followers') ? undefined : json['instagram_followers'],
        'based_in': !exists(json, 'based_in') ? undefined : json['based_in'],
        'product_arrival': !exists(json, 'product_arrival') ? undefined : json['product_arrival'],
        'min_lead_time': !exists(json, 'min_lead_time') ? undefined : json['min_lead_time'],
        'max_lead_time': !exists(json, 'max_lead_time') ? undefined : json['max_lead_time'],
        'minimum_quantity': !exists(json, 'minimum_quantity') ? undefined : json['minimum_quantity'],
        'minimum_price': !exists(json, 'minimum_price') ? undefined : json['minimum_price'],
        'categories': !exists(json, 'categories') ? undefined : json['categories'],
        'is_published': !exists(json, 'is_published') ? undefined : json['is_published'],
        'increment': !exists(json, 'increment') ? undefined : json['increment'],
        'instagram_growth_help': !exists(json, 'instagram_growth_help') ? undefined : json['instagram_growth_help'],
        'minimum_order_value': !exists(json, 'minimum_order_value') ? undefined : json['minimum_order_value'],
        'minimum_reorder_value': !exists(json, 'minimum_reorder_value') ? undefined : json['minimum_reorder_value'],
        'thumbnail_image_url': !exists(json, 'thumbnail_image_url') ? undefined : json['thumbnail_image_url'],
        'vanity_url_name': !exists(json, 'vanity_url_name') ? undefined : json['vanity_url_name'],
        'values': !exists(json, 'values') ? undefined : ((json['values'] as Array<any>).map(DropdownItemFromJSON)),
        'case_pack_quantity': !exists(json, 'case_pack_quantity') ? undefined : json['case_pack_quantity'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'bulletin_plus_access_level': !exists(json, 'bulletin_plus_access_level') ? undefined : json['bulletin_plus_access_level'],
        'onboarding_complete': !exists(json, 'onboarding_complete') ? undefined : json['onboarding_complete'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'fulfillment_address': !exists(json, 'fulfillment_address') ? undefined : json['fulfillment_address'],
        'balance_id': !exists(json, 'balance_id') ? undefined : json['balance_id'],
        'phone_number': !exists(json, 'phone_number') ? undefined : json['phone_number'],
        'shopify': !exists(json, 'shopify') ? undefined : ShopifyBrandOrdersFromJSON(json['shopify']),
    };
}

export function BrandResponseToJSON(value?: BrandResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'email': value.email,
        'brand_name': value.brand_name,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'brand_description': value.brand_description,
        'logo_url': value.logo_url,
        'brand_bio_image_url': value.brand_bio_image_url,
        'website_url': value.website_url,
        'instagram_url': value.instagram_url,
        'instagram_followers': value.instagram_followers,
        'based_in': value.based_in,
        'product_arrival': value.product_arrival,
        'min_lead_time': value.min_lead_time,
        'max_lead_time': value.max_lead_time,
        'minimum_quantity': value.minimum_quantity,
        'minimum_price': value.minimum_price,
        'categories': value.categories,
        'is_published': value.is_published,
        'increment': value.increment,
        'instagram_growth_help': value.instagram_growth_help,
        'minimum_order_value': value.minimum_order_value,
        'minimum_reorder_value': value.minimum_reorder_value,
        'thumbnail_image_url': value.thumbnail_image_url,
        'vanity_url_name': value.vanity_url_name,
        'values': value.values === undefined ? undefined : ((value.values as Array<any>).map(DropdownItemToJSON)),
        'case_pack_quantity': value.case_pack_quantity,
        'user_id': value.user_id,
        'bulletin_plus_access_level': value.bulletin_plus_access_level,
        'onboarding_complete': value.onboarding_complete,
        'address': value.address,
        'fulfillment_address': value.fulfillment_address,
        'balance_id': value.balance_id,
        'phone_number': value.phone_number,
        'shopify': ShopifyBrandOrdersToJSON(value.shopify),
    };
}

